import $ from 'jquery';
import { loadScript } from './util/loader';
import renderTemplate from './util/template';
import limelightHtml5Template from './views/limelight-html5.tpl.html';

const makePlayerID = () => {
  const num = Math.floor(Math.random() * 900000) + 100000;
  return `limelight_player_${num}`;
};

const buildPlayer = (video) => {
  const {
    playerId = makePlayerID(),
    contentType = 'channel'
  } = video.dataset;

  if (!video.dataset.playerId) {
    video.dataset.playerId = playerId;
  }

  if (!video.dataset.contentType) {
    video.dataset.contentType = contentType;
  }

  return renderTemplate(limelightHtml5Template, { playerId });
};

export default () => {
  // Embeds should NOT contain <script> tags, that is handled here now
  const limelightComponents = $('.limelight-component');

  loadScript('//video.limelight.com/player/limelightjs-player.js').then(() => {
    limelightComponents.each((index, video) => {
      const contentIdKey = (video.dataset.contentType === 'media') ? 'mediaId' : 'channelId';
      const html = buildPlayer(video);
      $(video).append(html);
      // eslint-disable-next-line no-undef
      LimelightPlayerUtil.embed({
        playerId: video.dataset.playerId,
        [contentIdKey]: video.dataset.contentId,
        playerForm: video.dataset.playerFormId
      });
    });
  });
};



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/limelight.js